
import React, { FC } from 'react';
import { PlusCircle } from 'react-bootstrap-icons';
import { CustomButtonProptypes, GenericButton } from '.';

export const AddButton: FC<CustomButtonProptypes> = ({
  // id = 'add-button',
  color = 'green',
  fontSize = '1rem',
  tooltip = "Add",
  ...props
}) => {
  return <GenericButton
    // id={id}
    color={color}
    tooltip={tooltip}
    {...props}
  >
    <PlusCircle color={color} fontSize={fontSize} />
  </GenericButton>
}
